<zf-selector-list
  [activeIndex]="activeIndex"
  [items]="items"
  [header]="header"
  (onElementSelect)="handleElementClick($event)"
></zf-selector-list>
